const CART = 'shopify_local_store__cart';
const CHECKOUT_ID = 'shopify_local_store__checkout_id';

export const LocalStorageKeys = {
	CART,
	CHECKOUT_ID,
};
